import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ConjuntoCategoriaContabil} from '../../../../core/conjunto-categoria-contabil';

@Component({
    selector: 'app-selecionar-argumento-dialog',
    templateUrl: './selecionar-conjunto-categoria-contabil-dialog.component.html',
    styleUrls: ['./selecionar-conjunto-categoria-contabil-dialog.component.css']
})
export class SelecionarConjuntoCategoriaContabilDialogComponent implements OnInit {

    argumentos: ConjuntoCategoriaContabil[] = [];
    dataSource: MatTableDataSource<ConjuntoCategoriaContabil>;
    argumentoSelecionado: ConjuntoCategoriaContabil | null = null;
    displayedColumns: string[] = ['categoriaOrigem', 'categoriaDestino', 'tipoLancamento', 'selecionar'];

    constructor(
        private dialogRef: MatDialogRef<SelecionarConjuntoCategoriaContabilDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any
    ) {
        if (data && data.argumentos) {
            this.argumentos = data.argumentos;
            this.dataSource = new MatTableDataSource<ConjuntoCategoriaContabil>(this.argumentos);
        } else {
            this.dataSource = new MatTableDataSource<ConjuntoCategoriaContabil>([]);
        }
    }

    ngOnInit(): void {
    }

    selecionarArgumento(argumento: ConjuntoCategoriaContabil): void {
        this.argumentoSelecionado = argumento;
        // Confirmar automaticamente ao clicar no check
        this.confirmar();
    }

    confirmar(): void {
        if (this.argumentoSelecionado) {
            this.dialogRef.close(this.argumentoSelecionado);
        }
    }

    cancelar(): void {
        this.dialogRef.close(null);
    }

    isSelecionado(argumento: ConjuntoCategoriaContabil): boolean {
        return this.argumentoSelecionado?.id === argumento.id;
    }
}

